import './index.scss'

import { mdiAlertCircleOutline, mdiAlertOutline, mdiCheckCircleOutline, mdiClose } from '@mdi/js'
import Icon from '@mdi/react'

import { Box } from '@/components/ui/box'
import { Text } from '@/components/ui/typography'
import { TToastStatus } from '@/types/gigiChat/Notifications'

const Toast = ({
    message,
    status,
    toastId,
    onClose,
    isHtml,
}: {
    message: string | React.ReactNode
    status: TToastStatus
    toastId: string
    onClose: (id: string) => void
    isHtml?: boolean
}) => {
    let color = 'tertiaryGreen.700'
    switch (status) {
        case 'success':
            color = 'tertiaryGreen.700'
            break
        case 'error':
            color = 'status.error'
            break
        case 'warning':
            color = 'status.warning'
            break
        default:
            break
    }

    let icon = mdiAlertCircleOutline
    switch (status) {
        case 'success':
            icon = mdiCheckCircleOutline
            break
        case 'warning':
            icon = mdiAlertOutline
            break
        default:
            break
    }

    const textColor = status === 'warning' ? 'var(--chakra-colors-dark-700)' : 'white'
    const isText = typeof message === 'string'
    return (
        <Box
            display="flex"
            justifyContent="space-between"
            bgColor={color}
            color={textColor}
            p="24px"
            borderRadius="4px"
            width="100%"
            alignItems="baseline"
            maxW={status === 'warning' ? 'inherit' : '650px'}
        >
            <Box display="flex" alignItems="center">
                <Icon path={icon} style={{ minWidth: '24px', maxWidth: '24px' }} />
                {isHtml && isText ? (
                    <Text className="toast-text" fontSize="14px" ml="16px" dangerouslySetInnerHTML={{ __html: message }} />
                ) : (
                    <Text fontSize="14px" ml="16px">
                        {message}
                    </Text>
                )}
            </Box>
            <Box cursor="pointer" onClick={() => onClose(toastId)} alignItems="center" ml="16px">
                <Icon path={mdiClose} size={1} />
            </Box>
        </Box>
    )
}

export default Toast
